import { render, staticRenderFns } from "./endors-renew-tips.vue?vue&type=template&id=167d3258&scoped=true&"
import script from "./endors-renew-tips.vue?vue&type=script&lang=js&"
export * from "./endors-renew-tips.vue?vue&type=script&lang=js&"
import style0 from "./endors-renew-tips.vue?vue&type=style&index=0&id=167d3258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d3258",
  null
  
)

export default component.exports